@if (importItems.length) {
  <div
    #importList
    class="import-list_button-container">
    <div
      class="import-list_button import-list_button--primary"
      (click)="isListShown = !isListShown">
      <i
        class="fas import-list_expand-icon"
      [ngClass]="{
        'fa-caret-right': !isListShown,
        'fa-caret-down': isListShown
      }">
      </i>
      <span class="import-list_button-text import-list_button-text--hidden-mobile">
        {{ 'importStatus' | translate }}
      </span>
      <i class="import-list_button-icon fas fa-file-import"></i>
      @if (notificationCount) {
        <div
          class="import-list_notification"
          matTooltip="{{ notificationCount + ' ' + ('importListNotification' | translate) }}"
          matTooltipPosition="above">
          {{ notificationCount }}
        </div>
      }
    </div>
    @if (isListShown) {
      <div class="import-list_container">
        @for (item of importItems; track trackByFn($index, item)) {
          <div class="import-list_item">
            <div class="import-list_content">
              <div class="import-list_name">
                {{ item?.test_report }}
              </div>
              <div
                class="import-list_status"
          [ngClass]="{
            'import-list_status--green': isExtractionSucceeded(item),
            'import-list_status--orange text--blink': isProcessing(item),
            'import-list_status--red': isExtractionFailed(item) || isUploadFailed(item)
          }">
                {{ item?.extraction_status_client || item?.extraction_status }}
              </div>
              @if (isUploadFailed(item)) {
                <div
                  class="import-list_error">
                  {{ item?.error_client | translate }}
                </div>
              }
            </div>
            <div class="import-list_actions">
              @if (isVerifyShown(item)) {
                <span
                  class="import-list_button"
                  (click)="onVerify(item)">
                  {{ isExtractionSucceeded(item) ? ('verify' | translate) : ('resolve' | translate) }}
                </span>
              }
              @if (isCancelShown(item)) {
                <span
                  class="import-list_button"
                  (click)="onCancel(item)">
                  {{ 'cancel' | translate }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}